import { useMatches } from '@tanstack/react-router'

import { DEFAULT_DOCUMENT_TITLE } from '@/lib/documentTitle'
import { useDocumentTitle } from './useDocumentTitle'

export const useRouteTitle = () => {
  const matches = useMatches()

  const ownedByComponent = matches.some(
    (match) => match.staticData?.dynamicTitle,
  )

  const staticTitle = [...matches]
    .reverse()
    .find((match) => match.staticData?.title)?.staticData.title

  useDocumentTitle(
    ownedByComponent ? null : (staticTitle ?? DEFAULT_DOCUMENT_TITLE),
  )
}
